export const APP_TYPE = {
	LBM: 'Land Bank Management',
	REI: 'Real Estate Insights',
	GW: 'Gateway',
	IH: 'Insights Hub',
	OM: 'OperationsManagement',
	CM: 'ConstructionManagement',
	G0: 'G0 Brief',
    GIS: 'GIS',
	XK: 'xkool'
};
